export default __webpack_public_path__ + "static/sketch_v2-35ba83836737256924aac2042138d87a.png";